import {IActionsState, initialActionsState, LoadingMassActionState} from '@app/core/store/state/actions.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {ActionsActions, EActionsActions} from '@app/core/store/actions/actions.actions';
import {EScheduleActions, ScheduleActions} from '@app/core/store/actions/schedule.actions';

export const actionsReducers = (
	state = initialActionsState,
	action: ActionsActions | ErrorActions | ScheduleActions,
): IActionsState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
				loadingMassActionState: LoadingMassActionState.NONE,
			};
		}
		case EActionsActions.GetShiftsPendingApproval: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EActionsActions.GetShiftsPendingApprovalSuccess: {
			return {
				...state,
				isLoading: false,
				shifts: action.shifts,
				pagination: action.pagination,
			};
		}
		case EScheduleActions.PatchShift:
		case EScheduleActions.DeleteShift: {
			return {
				...state,
				/*isLoading: true,*/
			};
		}
		case EScheduleActions.DeleteShiftSuccess: {
			return {
				...state,
				/*isLoading: false,*/
				shifts: state.shifts.filter(s => s.id !== action.shift.id)
			};
		}
		case EScheduleActions.PatchShiftSuccess: {
			return {
				...state,
				/*isLoading: false,*/
				shifts: state.shifts.filter(s => !(s.id === action.shift.id && action.shift.approved))
			};
		}
		case EActionsActions.DeleteShifts: {
			return {
				...state,
				loadingMassActionState: LoadingMassActionState.REMOVING,
			};
		}
		case EActionsActions.ApproveShifts: {
			return {
				...state,
				loadingMassActionState: LoadingMassActionState.APPROVING,
			};
		}
		case EActionsActions.DeleteShiftsSuccess:
		case EActionsActions.ApproveShiftsSuccess: {
			return {
				...state,
				loadingMassActionState: LoadingMassActionState.NONE,
				shifts: state.shifts.filter(s => action.ids.indexOf(s.id) === -1)
			};
		}
		case EActionsActions.GetShiftRequests: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EActionsActions.GetShiftRequestsSuccess: {
			return {
				...state,
				isLoading: false,
				shiftRequests: action.shifts,
				shiftRequestsPagination: action.pagination,
			};
		}
		case EActionsActions.GetShiftSwapRequests: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EActionsActions.GetShiftSwapRequestsSuccess: {
			return {
				...state,
				isLoading: false,
				shiftSwapRequests: action.shifts,
				shiftRequestsPagination: action.pagination,
			};
		}
		case EActionsActions.ApproveShiftRequestSuccess: {
			return {
				...state,
				shiftRequests: state.shiftRequests.filter(s => s.id !== action.shift.id),
				shiftSwapRequests: state.shiftSwapRequests.filter(s => s.id !== action.shift.id),
			};
		}
		case EActionsActions.RemoveShiftRequestSuccess: {
			return {
				...state,
				shiftRequests: state.shiftRequests.filter(s => s.id !== action.shift.id),
				shiftSwapRequests: state.shiftSwapRequests.filter(s => s.id !== action.shift.id),
			};
		}
		default:
			return state;
	}
};
